<nav class="breadcrumb-container">
  <div class="breadcrumb" *ngFor="let link of breadCrumbs; let $last = last; let $index = index">
    <a *ngIf="!$last && link !== keySystem?.topMasterKeyName" (click)="goTo($index)" class="breadcrumb link accent">
      <b>{{ link }}</b>
    </a>

    <div class="more" *ngIf="!$last && link === keySystem?.topMasterKeyName" [matMenuTriggerFor]="actions">
      <b>{{ link }}</b>
      <mat-icon>expand_more</mat-icon>
    </div>

    <div class="slash" *ngIf="!$last">/</div>

    <div class="breadcrumb" *ngIf="$last">
      <div class="more" *ngIf="link !== keySystem?.topMasterKeyName">
        {{ link }}
      </div>
      <div class="more" *ngIf="link === keySystem?.topMasterKeyName" [matMenuTriggerFor]="actions">
        {{ link }}
        <mat-icon>expand_more</mat-icon>
      </div>
    </div>
  </div>

  <mat-menu #actions>
    <button
      [ngClass]="{
        selected: keySystemItem.topMasterKeyName === keySystem?.topMasterKeyName
      }"
      mat-menu-item
      *ngFor="let keySystemItem of structure?.keySystems"
      (click)="selectKeySystem(keySystemItem)"
    >
      {{ keySystemItem?.topMasterKeyName }}
    </button>
    <button class="new" mat-menu-item (click)="openDialog()">
      <mat-icon>add</mat-icon>
      New Independent System
    </button>
  </mat-menu>
</nav>
